export default __webpack_public_path__ + "static/chrisFrame-e66e0fa6658cd4254f332f4343c7898b.webp";